export var ExpansionPanelDetailsOverrides = function () { return ({
    MuiExpansionPanelDetails: {
        root: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
}); };
//# sourceMappingURL=ExpansionPanelDetails.overrides.js.map